import React from 'react';
import { useSubheader } from '../../_metronic/layout';
import CoinTable from '../components/CoinTable';

const CoinPage = () => {
    const suhbeader = useSubheader();
    suhbeader.setTitle('Coins');

    return (
        <div>
            <CoinTable />
        </div>
    );
};

export default CoinPage;
